<template>
  <div>
    <page-main
      ref="main"
      v-if="showList"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @updateTotCount="updateTotCount"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @batchCancel="batchCancel"
        @batchExport="batchExport"
        @changeTable="changeTable"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
import PageMain from "./main"
import PageHeader from "./header"
import BaseTable from "@/mixins/base-table"
import dayjs from '@/libs/util.date'

export default {
  components: {
    PageMain,
    PageHeader,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      showList: true,
      showCustomer: false,
      showPoint: false,
      showCity: false,
    }
  },
  methods: {
    getData(form) {
      if (this.showList) {
        this.listData(form)
      } else if (this.showCustomer) {
        this.listCustomer(form)
      } else if (this.showPoint) {
        this.listPoint(form)
      } else if (this.showCity) {
        this.listCity(form)
      }
    },
    listData(form) {
      this.loading = true
      this.$api
        .bizDispatchPoolListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    listCustomer(form) {
      this.loading = true
      this.$api
        .bizDispatchPoolListGroupByCustApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    listPoint(form) {
      this.loading = true
      this.$api
        .bizDispatchPoolListGroupByPointApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    listCity(form) {
      this.loading = true
      this.$api
        .bizDispatchPoolListGroupByCityApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    async batchExport(type) {
      let url = '/order/bizDispatchPool/export'
      let fileName = '已调度记录导出'
      let form = { dispatchOrderStatusList:['Y'] }
      if (type === 'choose'){
        const listCode = await this.$refs.main.batchExport()
        if (listCode === undefined || listCode === null || listCode.length === 0){
          return
        }
        form.listCode = listCode
      }else{
        form.createTime = dayjs(new Date()).format('YYYY-MM-DD')
      }
      this.$api.bizDispatchPoolCheckExportApi(form)
        .then((res) => {
          const status = res.status
          if (status === 200){
            this.$api.globalExportData(url, form, fileName)
          }
        })
    },
    batchCancel() {
      this.$refs.main.batchCancel()
    },
    changeTable(type) {
      if (type === "customer") {
        this.showList = false
        this.showPoint = false
        this.showCity = false
        this.showCustomer = true
      } else if (type === "point") {
        this.showList = false
        this.showCustomer = false
        this.showCity = false
        this.showPoint = true
      } else if (type === "city") {
        this.showList = false
        this.showCustomer = false
        this.showPoint = false
        this.showCity = true
      } else {
        this.showCustomer = false
        this.showPoint = false
        this.showCity = false
        this.showList = true
      }
      this.$refs.header.query({ isReset: true })
    },
    updateTotCount(val){
      this.$refs.header.updateTotCount(val)
    },
  },
}
</script>
